<sz-modal
  [width]="'448px'"
  [height]="'548px'"
  [showTitle]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [(visible)]="visible"
  >
    <div class="py-16 flex flex-col items-center px-24 max-w-sm modal-content">
        <img
          src="../../../../assets/icons/success.svg"
          [width]="103"
          [height]="103"
          alt="icon-success"
        />
        <label class="my-8 text-brand-500 font-medium text-7xl">
          Success
        </label>
        <p class="text-base font-normal text-brand-500 text-center min-w-[20rem]">
          {{message}}
        </p>
      </div>
  </sz-modal>
